<div modalHeader class="modal-header py-2">
  <h2 class="my-2"><b>{{ title }} schedule</b></h2>
  <tr-icon [icon]="icon.cancel" classes="close-btn ml-auto py-1 px-2" (click)="cancel()"></tr-icon>
</div>

<form modalContent role="form" class="tr-form-services" *ngIf="schedulesForm" [formGroup]="schedulesForm">
  <div class="modal-body pb-0 pt-1">
    <div class="row form-group">
      <div class="col-xs-12 col-sm-12">
        <label for="schedule-name" class="lead col-form-label">Name</label>
      </div>
      <div class="col-xs-12 col-sm-12">
        <div class="d-flex">
          <input type="text"
                 class="form-control"
                 id="schedule-name"
                 formControlName="name"
                 name="scheduleName"
                 placeholder="Enter name"
                 [class.is-invalid]="schedulesForm.get('name').invalid && schedulesForm.get('name').touched">
        </div>
      </div>
    </div>
    <div *ngIf="schedulesForm.getError('validSchedule')" class="error-messages">This schedule's hours must be a subset of your default {{ schedules[0].name }}'s hours.</div>
    <div *ngIf="schedulesForm.getError('validDefaultSchedule')" class="error-messages">
      The {{ secondarySchedulesName }} will not fit the updated business hours.
      You should update the secondary schedule first before make changing in business hours.
    </div>
    <div *ngIf="schedulesForm.getError('validScheduleExceptions')" class="error-messages">Schedule is conflicting with exceptions.</div>

    <div class="mb-2 d-flex justify-content-end text-nowrap">
      <button
        type="button"
        class="btn btn-info"
        (click)="applyToAll()">
        <span class="bi bi-arrow-down"></span>Apply to all
      </button>
    </div>

    <div class="table-content w-100">
      <table formGroupName="hours">
        <tr *ngFor="let day of daysInWeek" [formGroupName]="day">
          <td class="col-day">
            <div class="col-center">
              <p class="time">{{ day }}</p>
            </div>
          </td>
          <td class="p-1 text-center">
            <div class="col-center">
              <div class="timepicker">
                <tr-timepicker-input [elementId]="day + '-1'" formControlName="hoursFirstValueFirstArray" [class.invisible]="schedulesForm.get('hours.'+ day +'.closed').value"></tr-timepicker-input>
                <control-messages [control]="schedulesForm.get('hours.' + day)"></control-messages>
              </div>

              <div class="timepicker ml-2">
                <tr-timepicker-input [elementId]="day + '-3'" formControlName="hoursSecondValueFirstArray" [class.invisible]="schedulesForm.get('hours.'+ day +'.closed').value"></tr-timepicker-input>
                <control-messages [control]="schedulesForm.get('hours.' + day)"></control-messages>
              </div>
            </div>
          </td>
          <td class="p-1 text-center" *ngIf="!schedulesForm.get('hours.'+ day +'.closed').value && schedulesForm.get('splitHours').value">
            <div class="d-flex align-items-center">
              <p class="p-0 m-0">and</p>

              <div class="timepicker ml-2">
                <tr-timepicker-input [elementId]="day + '-2'" formControlName="hoursFirstValueSecondArray"></tr-timepicker-input>
                <control-messages [control]="schedulesForm.get('hours.' + day)"></control-messages>
              </div>

              <div class="timepicker ml-2">
                <tr-timepicker-input [elementId]="day + '-4'" formControlName="hoursSecondValueSecondArray"></tr-timepicker-input>
                <control-messages [control]="schedulesForm.get('hours.' + day)"></control-messages>
              </div>
            </div>
          </td>
          <td>
            <div class="form-check col-center" [class.invisible]="schedulesForm.get('hours.'+ day +'.closed').value">
              <label class="form-check-label mx-2 text-nowrap">
                <input type="checkbox"
                       class="form-check-input"
                       formControlName="nextDay"
                       name="nextDay">
                Next day
              </label>
            </div>
          </td>
          <td [class.invisible]="schedulesForm.get('hours.'+ day +'.closed').value">
            <div class="form-check col-center">
              <label class="form-check-label mx-2 text-nowrap">
                <input type="checkbox"
                       class="form-check-input"
                       formControlName="publicDisabled"
                       name="publicDisabled">
                <span [ngbTooltip]="'The business is open but disable public check-ins and bookings'">
                  Disable public
                </span>
              </label>
            </div>
          </td>
          <td>
            <div class="form-check col-center">
              <label class="form-check-label mx-2">
                <input type="checkbox"
                       class="form-check-input"
                       formControlName="closed"
                       name="closed">
                Closed
              </label>
            </div>
          </td>
        </tr>
      </table>
    </div>

    <div class="notions form-check py-2 px-3">
      <div>Are your hours split during a single day, such as 11am-2pm <em>and</em> 5-9pm?</div>
      <label class="form-check-label">
        <input type="checkbox"
               class="form-check-input"
               formControlName="splitHours"
               (click)="toggleSplitHours()">
        I'd like to enter two sets of hours for a single day
      </label>
    </div>
  </div>
</form>

<div modalFooter class="modal-footer">
  <button
    class="btn btn-info"
    type="submit"
    angularticsCategory="settings"
    angulartics2On="click"
    angularticsAction="Confirm Add/Edit schedule"
    [disabled]="schedulesForm.pristine || !schedulesForm.valid"
    (click)="confirm()"
  >Confirm</button>
  <button
    type="button"
    class="btn btn-danger"
    (click)="cancel()"
    angularticsCategory="settings"
    angulartics2On="click"
    angularticsAction="Cancel Add/Edit Schedule"
  >Cancel</button>
</div>
